import React from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import * as User from '../helpers/User';
const win = window;
const $ = window.$;

export default class Flowplayer extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			randomid: new Date().getTime(),
			videosrtime: '',
		}
	}

	addvideocomponentcount() {
		/** video component count adding while play button click */
		let vcdata = this.props.vcdata;
		fetch(Config.domainUrl + 'videocomponent/addvideocount', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + Common.getTokenData()
			},
			body: JSON.stringify({ vcdata })
		}).then((response) => response.json()).then((responseJson) => {
			if (responseJson.islogout == 1) {
				Common.message('Note!', "Your account expired", 'info');
				Common.clearUserData();
				window.location.href = window.location + "/#/login";
			}
		});
	}

	componentDidMount() {
		// console.log(this.props);
		let vcdata = this.props.vcdata;
		let corporate_id=Common.getUserData("corporateID", true);
		let self = this;
		let count = 0;
		let againstart = 0;
		let flowPlayer = win.flowplayer($("#fphlsjs_" + this.state.randomid),
			this.props.playlist
		);

		//custom code
		$("#fphlsjs_"+this.state.randomid).find(".fp-engine").attr('preload', 'metadata');
		// .on('load', function(){
		// 	/** video component count adding while play button click */
		// 	if(vcdata!=undefined && vcdata.compo_type=='videocomponent'){
		// 		self.addvideocomponentcount();
		// 	}
		// })
		
		flowPlayer.on("progress.seek", function (e, api) {
			//console.log(e);
			//player time-each 10 sec call function
			// console.log(api);
			if (((Math.round(api.video.time * Math.pow(10, 0)) / Math.pow(10, 0))) % 10 == 0 && count < (Math.round(api.video.time * Math.pow(10, 0)) / Math.pow(10, 0))) {
				count = (Math.round(api.video.time * Math.pow(10, 0)) / Math.pow(10, 0));
				//self.tracker(api.video,'progress');   temporary comment by sampath 23-10-2019
				self.setState({ videosrtime: api.video });
			}
		}).on("ready", function (e, api) {
			var thumbheight = Math.round($(root).height() / 8);
			$(".fp-player:first", root).append($("<canvas/>").attr({
				height: thumbheight,
				width: Math.round(thumbheight * api.video.width / api.video.height)
			}));
			againstart = 1;// first play
			//self.tracker(api.video,'ready');
			//console.log(" in ready")
			// $("a[href$='player']").css("display", "none");
			if (corporate_id==87) {
				$("a[href$='player']").html('<marquee direction="down" behavior="alternate" style="border:solid"> <marquee behavior="alternate">  Downloading this video illegal </marquee> </marquee>');
			}
			$("a[href$='player']").css("background-image", "none");
			$("a[href$='player']").css("width", "400px");
			$("a[href$='player']").css("pointer-events", "none");
			//$("a[href$='player']").attr("href", "");
		}).on("pause", function (e, api) {
			self.tracker(api.video, 'pause');
			//console.log(" in pause")
			//video end    
			
			if (corporate_id==87) {
				$("a[href$='player']").html('<marquee direction="down" behavior="alternate" style="border:solid"> <marquee behavior="alternate">  Downloading this video illegal </marquee> </marquee>');
			}
			$("a[href$='player']").css("background-image", "none");
			$("a[href$='player']").css("width", "400px");
			$("a[href$='player']").css("pointer-events", "none");
			//$("a[href$='player']").attr("href", "");
		}).on("resume", function (e, api) {
			//alert(againstart);
			if (corporate_id==87) {
				$("a[href$='player']").html('<marquee direction="down" behavior="alternate" style="border:solid"> <marquee behavior="alternate">  Downloading this video illegal </marquee> </marquee>');
			}
			$("a[href$='player']").css("background-image", "none");
			$("a[href$='player']").css("width", "400px");
			$("a[href$='player']").css("pointer-events", "none");
			//$("a[href$='player']").attr("href", "");
			if (againstart == 1) {
				againstart = 0;
				self.tracker(api.video, 'ready');
				if (vcdata != undefined && vcdata.compo_type == 'videocomponent') {
					self.addvideocomponentcount();
				}
			}
			else {
				self.tracker(api.video, 'resume');
			}
			// console.log(" in resume")
			//video end    
		}).on("finish", function (e, api) {
			count = 0;
			againstart = 1;
			//console.log(" in end")
			self.tracker(api.video, 'end');
		});
	}

	tracker(details, state) {
		if (this.props.trackData != undefined) {
			let trackData = this.props.trackData;
			// console.log(trackData);
			trackData['geo_location'] = (localStorage.getItem("geo_location" + Config.app_name) != undefined) ? localStorage.getItem("geo_location" + Config.app_name) : "";
			trackData['product_id'] = Common.getUserData("productID", true);
			trackData['corporate_id'] = Common.getUserData("corporateID", true);
			trackData['total_duration'] = details.duration;
			trackData['watched_time'] = details.time;
			trackData['url'] = details.url;
			trackData['media_type'] = details.type;
			trackData['status'] = state;

			// fetch(Config.domainUrl + 'learner-video-track-logs/video-track', {
			// 	method: 'POST',
			// 	headers: {
			// 		'Accept': 'application/json',
			// 		'Content-Type': 'application/json'
			// 	},
			// 	body: JSON.stringify({ trackData })
			// }).then((response) => response.json()).then((responseJson) => {
			// 	// console.log(responseJson);
			// });    temporary comment on 22-05-2020 told by subbu
		}
	}

	componentWillUnmount() {
		// alert('tt');
		//let videotime=localStorage.getItem('videosrtime');
		let videotime = this.state.videosrtime;
		this.tracker(videotime, 'progress');
	}

	componentWillReceiveProps(nextProps) {

	}

	render() {
		let randkey = this.state.randomid;
		return (
			<span id={`fphlsjs_${randkey}`}  ></span>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Flowplayer.js